module.exports = __webpack_public_path__ + "static/media/400424_01.f00bc8d6.png";